import React from 'react';
import { defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { classNameWithModifiers as withMods } from 'helpers/class-name';

import Message from 'components/Message';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'components/Dropdown2';
import './VenueSelector.scss';

const messages = defineMessages({
  invalidVenue: {
    id: 'venue-selector.invalid-venue',
    defaultMessage: 'Invalid venue',
  },
  venueName: {
    id: 'venue-selector.venue-name',
    defaultMessage: '{venueSubtitle, select, undefined {{venueName}} other {{venueName} ({venueSubtitle})}}',
  },
  label: {
    id: 'venue-selector.label',
    defaultMessage: 'Location',
  },
});

const VenueSelector = ({ activeVenueId, onChange, changeActiveVenue, venuesList = [], useHeaderStyle }) => {
  if (venuesList.length < 2) return null;

  const selectedVenue = venuesList.find(({ venueId }) => venueId === activeVenueId);

  return (
    <div className={withMods('venue-selector', { padded: useHeaderStyle })} data-cypress="venue-selector">
      <Dropdown attachment="left">
        <DropdownToggle label={messages.label}>
          <Message message={selectedVenue ? messages.venueName : messages.invalidVenue} values={selectedVenue} />
        </DropdownToggle>
        <DropdownMenu>
          {venuesList.map(venue => {
            const { venueId } = venue;
            return (
              <DropdownItem
                key={venueId}
                isSelected={venueId === activeVenueId}
                onClick={() => (onChange || changeActiveVenue)(venue)}
                data-cypress={`venue-selector-item-${venueId}`}>
                <Message message={messages.venueName} values={venue} />
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

VenueSelector.propTypes = {
  activeVenueId: PropTypes.number,
  changeActiveVenue: PropTypes.func,
  onChange: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  venuesList: PropTypes.arrayOf(PropTypes.any),
  useHeaderStyle: PropTypes.bool,
};

export default VenueSelector;
